import React from 'react';
import Button from '../Button/Button';

import './GamePage.css';

const GamePage = (props) => {

    let letterStyle = '';
    if (props.letterStyle === "1") letterStyle = 'glasnyi';
    else {
        if (props.letterStyle === "2") {
            letterStyle = 'soglasnyi';
        }
		else letterStyle = 'glasn';
    };
    let GameWord = '';
    if (props.curImg) {
        let idLetter = props.curImg.word.indexOf(props.letter);
        if (idLetter === 0) {
            GameWord = (<div><span className={letterStyle + ' big'} >{props.letter}</span>{props.curImg.word.slice(1)}</div>);
        }
        else {
            if (idLetter === props.curImg.word.length - 1) GameWord = (<div>{props.curImg.word.slice(0, (props.curImg.word.length - 1))}<span className={letterStyle} >{props.letter}</span></div>);
            else GameWord = (<div>{props.curImg.word.slice(0, (idLetter))}<span className={letterStyle} >{props.letter}</span>{props.curImg.word.slice(idLetter+1)}</div>);
        }
    };
 
    return (
        <div>
            <img src={props.srcBg} className='bgGame' alt=' ' />
            {props.isLetter ? (<div><div className='gameCircle'  >  </div> <div className={'letterPlace ' + letterStyle}> {props.letter} </div></div>) :
                (<div><img src={props.src} className='bigImg' alt = '' />  <div className='GamesWord'> {GameWord} </div></div>)}
            <Button className='GamePrev' onClick={() => props.onClick('prev')} />
            <Button className='GameNext' onClick={() => props.onClick('next')} />
            <Button className='Abc' onClick={() => props.onClick('abc')} value={(props.lang === 'fin') ? 'ABC' : 'АБВ'} />
        </div>
    );
};

export default GamePage;